import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  #admin = 'https://api-adminclient.rflatina.com/rfl/api/v1/';
  

  constructor(
    private httpClient: HttpClient,
    private cookies: CookieService
  ) { }

  logIn(email, password){
    const headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('origen', 'aleema_remake');

    const apiURL = this.#admin+'login';
    const body = JSON.stringify({ email, password });
    return this.httpClient.post(`${apiURL}`,body ,{ headers: headers}).pipe(
      map( response =>{
        localStorage.setItem('token', response['token']);
        localStorage.setItem('language', 'es');
      }),catchError(error =>{
        return error
      })
    );
  }
  logOut(){
    this.cookies.deleteAll('/');
    localStorage.clear();
    sessionStorage.clear();
  }
  isLogIn(){
    return !!localStorage.getItem('token');
  }
  forgotPassword(email){
    return this.httpClient.get(this.#admin+'reset?email='+email);
  }
}
